import { ReactNode } from "react"
import { AddToDocumentHead } from "./AddToDocumentHead"

interface Props {
  children: ReactNode
}

export const DocumentTitleOverride: React.FC<Props> = (props: Props) => {
  const { children } = props
  if (!children) return null
  return (
    <AddToDocumentHead>
      <title>{children}</title>
    </AddToDocumentHead>
  )
}
